import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { settings } from ".";

export const definition: WidgetDefinition = {
  id: "ip-blocking-indicator",
  module: widgetModule,
  catalog: {
    description:
      "One or two figures of the IP blocking report — IPs detected and sent for blocking, blocking ratios per channel — with their trend.",
    domain: "ip-blocking",
    visual: "KPI",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpi" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
